var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spaceAround home-banner" },
    [
      _c("img", {
        staticClass: "home-logo",
        attrs: { src: require("../../../assets/logo/logo.png") },
        on: {
          click: function ($event) {
            return _vm.gowww()
          },
        },
      }),
      _vm._v(" "),
      _c("menu-nav"),
      _vm._v(" "),
      _c("img", {
        staticClass: "home-logo is-phone",
        attrs: { src: require("../../../assets/logo/logo.png") },
        on: {
          click: function ($event) {
            return _vm.gowww()
          },
        },
      }),
      _vm._v(" "),
      _vm.account
        ? _c(
            "div",
            [
              _c(
                "el-button",
                {
                  staticClass: "mm-button",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                  },
                  on: { click: _vm.handleClose },
                },
                [
                  _vm.fromType1 == "Ethereum"
                    ? _c("img", {
                        staticStyle: {
                          width: ".24rem",
                          height: ".24rem",
                          "margin-right": ".1rem",
                        },
                        attrs: {
                          src: require("@/assets/image/transfer/eth.png"),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fromType1 == "Treasurenet"
                    ? _c("img", {
                        staticStyle: {
                          width: ".24rem",
                          height: ".24rem",
                          "margin-right": ".1rem",
                        },
                        attrs: {
                          src: require("@/assets/image/exchange/unit.png"),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("Account", { attrs: { value: _vm.account } }),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "el-button",
            {
              staticClass: "mm-button",
              attrs: { loading: _vm.loading, disabled: _vm.isConnect },
              on: { click: _vm.connectMetaMask },
            },
            [
              _c(
                "span",
                {
                  staticClass: "mm-text",
                  attrs: { id: "metaMask_connectButton" },
                },
                [_vm._v(_vm._s(_vm.btnText))]
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }